const DEFAULT_HOMEPAGE_SEARCH_TITLE = 'Cerca il veicolo su misura per te'
const DEFAULT_HOMEPAGE_SEARCH_DESCRIPTION = 'Compila le preferenze e trova il veicolo più adatto alle tue esigenze'

export function resolveHomepageSearchTitle(
  slideTitle?: string | null,
  globalTitle?: string | null,
) {
  return slideTitle?.trim() || globalTitle?.trim() || DEFAULT_HOMEPAGE_SEARCH_TITLE
}

export function resolveHomepageSearchDescription(
  slideDescription?: string | null,
  globalDescription?: string | null,
) {
  return slideDescription?.trim() || globalDescription?.trim() || DEFAULT_HOMEPAGE_SEARCH_DESCRIPTION
}
